import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=e5bb27f6&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=e5bb27f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bb27f6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5bb27f6')) {
      api.createRecord('e5bb27f6', component.options)
    } else {
      api.reload('e5bb27f6', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=e5bb27f6&scoped=true&", function () {
      api.rerender('e5bb27f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shared/layouts/components/Footer.vue"
export default component.exports